var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.showDialog },
          on: {
            "update:mdActive": function($event) {
              _vm.showDialog = $event
            },
            "update:md-active": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("md-dialog-title", [_vm._v("Add a technogym staff")]),
          _vm._v(" "),
          _c(
            "md-dialog-content",
            [
              _c("field", {
                ref: "email",
                attrs: {
                  fieldName: "email",
                  validations: { required: true, email: true },
                  fieldValue: _vm.form.email,
                  fieldLabel: "Email",
                  fieldId: "email",
                  sending: _vm.sending
                },
                on: {
                  setfield: function($event) {
                    return _vm.setFormField($event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                { staticClass: "md-primary", on: { click: _vm.hideDialog } },
                [_vm._v("Close")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: { click: _vm.validateAndSave }
                },
                [_vm._v("Save")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e05dfa3", { render: render, staticRenderFns: staticRenderFns })
  }
}